import { connect } from 'react-redux'
import { createConnector, InferConnectedProps } from '../../../../redux/createConnector'
import { toggleNotesOn } from '../../../../redux/notes/actions'
import CellWithNotes, { IProps } from './CellWithNotes'

const actions = {
  toggleNotesOn,
}
const connector = connect(null, actions)
export type PropsFromRedux = InferConnectedProps<typeof connector, typeof actions>
export default createConnector<typeof connector, IProps, PropsFromRedux>(connector, CellWithNotes)
